import { render, staticRenderFns } from "./DiscardDraftMenuButton.vue?vue&type=template&id=3913f200&"
import script from "./DiscardDraftMenuButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DiscardDraftMenuButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports